import { apiPost } from '@/services/api/client';

export async function deleteShiftRemote(shiftId: string): Promise<void> {
  await apiPost('delete_shift', { shiftId }, { timeoutMs: 20_000 });
}
